"use strict";

angular.module('PatientApp').service('PaymentFormsGatewayService', function (VuexStore) {
  return {
    // Called when we want to submit a new paymentForm.
    submit: function submit(paymentForm) {
      return VuexStore.dispatch('submitPaymentForm', {
        paymentForm: paymentForm
      });
    },
    // When we call this process if it gets to the confirmation
    // step it will request that the user manually resubmit the form
    // this is to buy us some time between NMI being ready and
    // our server call
    resume: function resume() {
      return VuexStore.dispatch('resumePreviousPaymentFormAttempt');
    }
  };
});